export enum MessagePlatform {
	chat = 'Chat',
	sms = 'SMS',
	system = 'System',
	unknown = 'Unknown',
}
